/** 邮箱验证 */
export const emailReg = /^[A-Z0-9a-z._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,4}$/;

/** 邮箱密码验证（必须是字母 + 数字） */
export const passwordReg = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,15}$/;

/** 验证码 */
export const captchaReg = /^\d{6}$/;

/** 网址 */
export const urlReg =
    /^(?:(http|https|ftp):\/\/)?((|[\w-]+\.)+[a-z0-9]+)(?:(\/[^/?#]+)*)?(\?[^#]+)?(#.+)?$/i;
